// TODO: Fix this component

type Props = any;

// export const Can = createContextualCan(AbilityContext.Consumer as Consumer<AnyAbility>);
export const Can = ({ children }: Props) => <>{children}</>;
